import { InjectionToken, Injector } from '@angular/core';

export type FeatureFlag = string;
export type FeatureFlagValue = boolean | ((injector: Injector) => boolean);

export type FeatureFlags<T extends FeatureFlag = FeatureFlag> = Record<T, FeatureFlagValue>;

export const FEATURE_FLAGS = new InjectionToken<FeatureFlags>('Feature Flags', {
  factory: () => ({}),
});
